var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522,
    height: 500,
    viewBox: "0 0 522 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#E9530D",
    strokeWidth: 10,
    d: "M504.92 182.26l-165.839-15.381L273.205 13.91c-4.612-10.711-19.799-10.711-24.411 0l-65.875 152.97L17.08 182.26C5.468 183.337.775 197.78 9.536 205.476l125.126 109.922-36.618 162.476c-2.564 11.376 9.722 20.302 19.749 14.348L261 407.188l143.207 85.034c10.027 5.954 22.314-2.972 19.75-14.348l-36.619-162.476 125.126-109.922c8.761-7.696 4.068-22.139-7.544-23.216z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLine);
export default __webpack_public_path__ + "static/media/other-line.56067f124a29c8de5d9a8335dd002f41.svg";
export { ForwardRef as ReactComponent };